import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        /*
        {
          name: "StarterPage",
          path: "starterpage",
          component: () => import("@/views/StarterPage"),
        },
        */
        {
          name: "PaymentHistory",
          path: "payment_history",
          component: () => import("@/views/PaymentHistory"),
          meta: { requiresAuth: true }
        },
        {
          name: "Payment",
          path: "payment",
          component: () => import("@/views/Payment"),
          meta: { requiresAuth: true }
        },
        /*
        {
          name: "Plan",
          path: "plan",
          component: () => import("@/views/Plan"),
          meta: { requiresAuth: true }
        },
        */
      ],
    },

    {
      path: "/authentication",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        
        {
          name: "BoxedLogin",
          path: "login",
          component: () => import("@/views/authentication/BoxedLogin"),
        },
        /*
        {
          name: "FullLogin",
          path: "fulllogin",
          component: () => import("@/views/authentication/FullLogin"),
        },
        {
          name: "BoxedRegister",
          path: "boxedregister",
          component: () => import("@/views/authentication/BoxedRegister"),
        },
        {
          name: "FullRegister",
          path: "fullregister",
          component: () => import("@/views/authentication/FullRegister"),
        },
        {
          name: "Error",
          path: "error",
          component: () => import("@/views/authentication/Error"),
        },
        */
        {
          name: "Logout",
          path: "logout",
          component: () => import("@/views/authentication/Logout"),
        },
      ],
    },

  ],
});

import NProgress from "nprogress";
//import firebase from "firebase/app";
//import "firebase/auth";

router.beforeResolve((to, from, next) => {
  //let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  //let currentUser = firebase.auth().currentUser
  // If this isn't an initial page load.
  //console.log('to', to);
  //console.log('from', from);
  //console.log('requresAuth? currentUser?', requiresAuth, currentUser);

  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
  
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
